import { HashLink } from 'react-router-hash-link';
import FirstRef from './FirstRef';
import LastRef from './LastRef';
import EvidenceLevel from './EvidenceLevel';
import OriginalDB from './OriginalDB';
import GenePMID from './GenePMID';

function AboutAttributesGeneDisease() {
  return (
    <div id="section46">
      <h3>Gene-Disease Associations</h3>
      <ul>
        <li className="bullet-item">
          The{' '}
          <HashLink smooth to="/About?section=metrics#gdaScore" className="js-fix-scroll">
            DISGENET score
          </HashLink>
        </li>
        <li className="bullet-item">
          The{' '}
          <HashLink smooth to="/About?section=assoctypeont#types-ontology" className="js-fix-scroll">
            DISGENET Gene-Disease Association Type
          </HashLink>
        </li>
        <EvidenceLevel />
        <li className="bullet-item">
          The{' '}
          <HashLink smooth to="/About?section=metrics#evindex" className="js-fix-scroll">
            Evidence Index
          </HashLink>
        </li>
        <FirstRef />
        <LastRef />
        <GenePMID />
        <li className="bullet-item">
          A representative sentence from the publication describing the association between the gene and the
          disease (if a representative sentence is not found, we provide the title of the paper)
        </li>
        <OriginalDB />
        <li className="bullet-item">
          Polarity: indicates the polarity level of the sentence; for instance if the sentence provides
          supporting evidence for the association, the polarity is positive. Otherwise, if the sentence
          provides non-supporting evidence for the association, the polarity is negative.
        </li>
        <li className="bullet-item">
          ​​“Chemical Effect”: classification of the effect of a chemical on the disease, provided by
          processing expert-curated resources that provide adverse effect information and indications. By
          using the “Chemical Effect” attribute, you can select chemicals that are used for the treatment of a
          disease (therapeutic) or lead to a disease (toxicity). In addition, for relations reported by
          ClinPGX, effects include Dosage, Efficacy, Metabolism/PK, PD.
        </li>
        <li className="bullet-item">
          My Score: a user-defined weighted score that allows users to assign weights to selected data sources
          contributing to the association. This score provides a customizable measure of confidence in a
          gene-disease association based on user preferences.
        </li>
        {['test', 'development', 'dev'].includes(process.env.REACT_APP_ENVIRONMENT || '') ||
          (process.env.NODE_ENV !== 'production' && (
            <>
              <li className="bullet-item">
                Translation: is the 
                <a
                  href="https://support.icite.nih.gov/hc/en-us/articles/9349049758875-Approximate-Potential-to-Translate-APT"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {' '}
                  Approximate Potential to Translate{' '}
                </a>
                  that identifies early signals of “bench-to-bedside” translation based on how the scientific
                community engages with and cites the work.
              </li>
            </>
          ))}
      </ul>
    </div>
  );
}

export default AboutAttributesGeneDisease;
